import { Box, Chip, IconButton, Typography } from "@mui/material";
import React from "react";
import LogoIcon from "../../../assets/images/logo-icon.png";
import variables from "../../../assets/styles/variables.module.scss";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import NewChatIcon from "../../../assets/icons/NewChatIcon";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

type RecentChatsProps = {
  onBack: () => void;
};

const RecentChats: React.FC<RecentChatsProps> = ({ onBack }) => {
  return (
    <Box
      sx={{
        height: "100%",
      }}
    >
      <Box
        position="sticky"
        sx={{
          borderBottom: "1px solid #f9f7f7",
          px: 2,
          py: 1.5,
          display: "flex",
          alignItems: "center",
          zIndex: 1,
          top: 0,
        }}
      >
        <IconButton aria-label="back" onClick={onBack}>
          <ArrowBackIcon />
        </IconButton>
        <Typography
          variant="h6"
          component="div"
          sx={{
            flexGrow: 1,
            textTransform: "capitalize",
            color: variables.blackColor,
            textAlign: "center",
          }}
        >
          Recent chats
        </Typography>
        <IconButton aria-label="back">
          <NewChatIcon />
        </IconButton>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "calc(100% - 96px)",
          display: "flex",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            maxHeight: "100%",
            overflow: "auto",
          }}
        >
          <Box
            sx={{
              px: 3.5,
              "&:hover": {
                backgroundColor: "#f5f5f5",
                cursor: "pointer",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2.5,
                py: 2.5,
                borderBottom: "1px solid #f3f2f2",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  flexShrink: "0",
                }}
              >
                <img
                  src={LogoIcon}
                  alt="Company Logo"
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "cover",
                  }}
                />
              </Box>
              <Box
                sx={{
                  minWidth: "0",
                  flex: 1,
                }}
              >
                <Typography
                  variant="subtitle2"
                  noWrap
                  sx={{
                    lineHeight: "20px",
                    textTransform: "capitalize",
                  }}
                >
                  ZeaTime AI Assistant
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: variables.textGray }}
                >
                  1 hour ago
                </Typography>
              </Box>
              <Box
                sx={{
                  flexShrink: "0",
                  display: "flex",
                  gap: 1,
                }}
              >
                <Chip
                  label="Open"
                  size="small"
                  sx={{
                    height: "22px",
                    backgroundColor: "#f0fdf4",
                    color: "#008236",
                  }}
                />
                <KeyboardArrowRightIcon />
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              px: 3.5,
              "&:hover": {
                backgroundColor: "#f5f5f5",
                cursor: "pointer",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2.5,
                py: 2.5,
                borderBottom: "1px solid #f3f2f2",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  flexShrink: "0",
                }}
              >
                <img
                  src={LogoIcon}
                  alt="Company Logo"
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "cover",
                  }}
                />
              </Box>
              <Box
                sx={{
                  minWidth: "0",
                  flex: 1,
                }}
              >
                <Typography
                  variant="subtitle2"
                  noWrap
                  sx={{
                    lineHeight: "20px",
                    textTransform: "capitalize",
                  }}
                >
                  ZeaTime AI Assistant
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: variables.textGray }}
                >
                  1 hour ago
                </Typography>
              </Box>
              <Box
                sx={{
                  flexShrink: "0",
                  display: "flex",
                  gap: 1,
                }}
              >
                <Chip
                  label="Open"
                  size="small"
                  sx={{
                    height: "22px",
                    backgroundColor: "#f0fdf4",
                    color: "#008236",
                  }}
                />
                <KeyboardArrowRightIcon />
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              px: 3.5,
              "&:hover": {
                backgroundColor: "#f5f5f5",
                cursor: "pointer",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2.5,
                py: 2.5,
                borderBottom: "1px solid #f3f2f2",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  flexShrink: "0",
                }}
              >
                <img
                  src={LogoIcon}
                  alt="Company Logo"
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "cover",
                  }}
                />
              </Box>
              <Box
                sx={{
                  minWidth: "0",
                  flex: 1,
                }}
              >
                <Typography
                  variant="subtitle2"
                  noWrap
                  sx={{
                    lineHeight: "20px",
                    textTransform: "capitalize",
                  }}
                >
                  ZeaTime AI Assistant
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: variables.textGray }}
                >
                  1 hour ago
                </Typography>
              </Box>
              <Box
                sx={{
                  flexShrink: "0",
                  display: "flex",
                  gap: 1,
                }}
              >
                <Chip
                  label="Open"
                  size="small"
                  sx={{
                    height: "22px",
                    backgroundColor: "#f0fdf4",
                    color: "#008236",
                  }}
                />
                <KeyboardArrowRightIcon />
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              px: 3.5,
              "&:hover": {
                backgroundColor: "#f5f5f5",
                cursor: "pointer",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2.5,
                py: 2.5,
                borderBottom: "1px solid #f3f2f2",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  flexShrink: "0",
                }}
              >
                <img
                  src={LogoIcon}
                  alt="Company Logo"
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "cover",
                  }}
                />
              </Box>
              <Box
                sx={{
                  minWidth: "0",
                  flex: 1,
                }}
              >
                <Typography
                  variant="subtitle2"
                  noWrap
                  sx={{
                    lineHeight: "20px",
                    textTransform: "capitalize",
                  }}
                >
                  ZeaTime AI Assistant
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: variables.textGray }}
                >
                  1 hour ago
                </Typography>
              </Box>
              <Box
                sx={{
                  flexShrink: "0",
                  display: "flex",
                  gap: 1,
                }}
              >
                <Chip
                  label="Open"
                  size="small"
                  sx={{
                    height: "22px",
                    backgroundColor: "#f0fdf4",
                    color: "#008236",
                  }}
                />
                <KeyboardArrowRightIcon />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default RecentChats;
